import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: { page: number; limit: number; query?: string }) => {
  const res = await httpRequest.get('/api/branch', data);
  return res;
};

export const create = async (data: { name: string; nameEng: string }) => {
  const res = await httpRequest.post('/api/branch', data);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/branch/${id}/detail`);
  return res;
};

export const select = async (payload: any) => {
  const res = await httpRequest.get(`/api/branch/select`, {
    ...payload,
    limit: 100,
  });
  return res;
};

export const remove = async (id: string) => {
  const res = await httpRequest.del(`/api/branch/${id}`);
  return res;
};

export const update = async ({
  id,
  name,
  nameEng,
  headId,
}: {
  id: string;
  name: string;
  nameEng: string;
  headId?: string;
}) => {
  const res = await httpRequest.put(`/api/branch/${id}/update`, { name, nameEng, headId: headId });
  return res;
};
